export default __webpack_public_path__ + "static/media/images.9ccbde90.svg";